var impressum = "기업정보";
var privacy = "개인정보처리방침";
var recallInfo = "리콜 정보";
var signOut = "로그아웃";
var ko_kr = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { ko_kr as default, impressum, privacy, recallInfo, signOut };
